import SiteConfig from "site-config.json";
const {
    AuthContent,
    HelpContent
} = require(`./${process.env.REACT_APP_SITE_CONFIG_PATH}/siteComponents`);

export { AuthContent, HelpContent };
export default SiteConfig;



// WEBPACK FOOTER //
// ./src/siteConfig/index.js